import { d as T } from "./index.es26.js";
import { __require as p } from "./index.es70.js";
var i, u;
function d() {
  if (u) return i;
  u = 1;
  var n = T, e = p(), a = n.isTag;
  i = {
    getInnerHTML: f,
    getOuterHTML: e,
    getText: t
  };
  function f(r, o) {
    return r.children ? r.children.map(function(g) {
      return e(g, o);
    }).join("") : "";
  }
  function t(r) {
    return Array.isArray(r) ? r.map(t).join("") : a(r) ? r.name === "br" ? `
` : t(r.children) : r.type === n.CDATA ? t(r.children) : r.type === n.Text ? r.data : "";
  }
  return i;
}
export {
  d as __require
};
//# sourceMappingURL=index.es50.js.map
